import React from 'react';

import NotFound from 'containers/NotFound';
import { EnhancedNextPage, EnhancedPageContext } from 'types/Next';

export interface With404PageProps<T> {
  props: T;
  notFound: boolean;
}

/**
 * Allows you to use an API similar to getServerSideProps
 * but with getInitialProps. Returns 404 NotFound if the
 * wrapped Page's getInitialProps returns notFound: true.
 * In other cases it will just pass the props to the wrapped
 * page.
 */
function with404<T extends Record<string, unknown>>(WrappedPage: EnhancedNextPage<T>) {
  const Page = ({ props, notFound }: With404PageProps<T>) => {
    if (notFound) {
      return <NotFound />;
    }
    return <WrappedPage {...props} />;
  };

  Page.getInitialProps = async (ctx: EnhancedPageContext) => {
    const pageProps = WrappedPage.getInitialProps ? await WrappedPage.getInitialProps(ctx) : {};

    return pageProps;
  };

  return Page;
}

export default with404;
